module.exports = __webpack_public_path__ + "static/logo-meiquer-ocotan-77ce1611c4506e1adfb52f99e782ada8.png";